<template>
  <div class="container-fluid px-3">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-6">
          <label for="section" class="form-label required">بخش هدف ارجاع</label>
          <vue-select v-model="section" :options="companySections" dir="rtl" label="title" :clearable="false"
            @click="getCompanySections()">
            <template #no-options="{ search, searching, loading }">
              موردی یافت نشد!
            </template>
          </vue-select>
        </div>
        <div class="col-md-6">
          <label for="role" class="form-label">نقش هدف ارجاع</label>
          <vue-select v-model="role" :options="roles" dir="rtl" label="title" @click="getRolesByCompanySection()">
            <template #no-options="{ search, searching, loading }">
              موردی یافت نشد!
            </template>
          </vue-select>
        </div>
        <div class="col-md-6">
          <label for="user" class="form-label">کاربر هدف ارجاع</label>
          <vue-select v-model="user" :options="users" dir="rtl" label="displayProp" @click="getUsersByCompanySection()">
            <template #no-options="{ search, searching, loading }">
              موردی یافت نشد!
            </template>
          </vue-select>
        </div>
        <div class="col-md-6">
          <label for="status" class="form-label">وضعیت جدید، اگر مایل به تغییر آن هستید</label>
          <vue-select v-model="status" :options="statuses" dir="rtl" label="title" @click="getStatusesByCompany()">
            <template #no-options="{ search, searching, loading }">
              موردی یافت نشد!
            </template>
          </vue-select>
        </div>
        <div>
          <label for="description" class="form-label">توضیحات</label>
          <div class="d-md-flex">
            <textarea class="form-control" rows="3" id="description" name="description" v-model.trim="description"></textarea>
            <chat-file-selector ref="referTicketFileSelector" dynamicId="trf" maxFileCount="5" :maxFileSize="50 * 1024 * 1024"
              validExtensions="rar,zip,doc,docx,pdf,xls,xlsx,ppt,pptx,txt,apng,png,avif,gif,jpg,jpeg,jfif,pjpeg,pjp,svg,webp"
              @filesUpdate="updateFiles" />
          </div>
        </div>
      </div>
      <hr class="horizontal dark" />
      <template v-if="v.$error">
        <show-errors :model-value="v.$errors"></show-errors>
        <hr class="horizontal dark" />
      </template>
      <div>
        <button class="btn bg-gradient-warning" type="submit" :disabled="lockButtons">ارجاع</button>
      </div>
    </form>
  </div>
</template>

<script>
import TicketService from '@/services/Ticket/Ticket-service.js';
import CompanyService from '@/services/Company/Company-service.js';
import UserService from '@/services/User/User-service.js';
import RoleService from '@/services/User/Role-service.js';
import BaseService from '../../services/Base-service';
import { maxLength, helpers, requiredIf } from '@vuelidate/validators';
import ChatFileSelector from '../components/File/ChatFileSelector.vue';

export default {
  emits: ['referred'],
  props: {
    ticket: {
      type: Object,
    }
  },
  components: { ChatFileSelector },
  data() {
    return {
      v: this.$useVuelidate(),
      description: '',
      section: null,
      companySections: [],
      role: null,
      roles: [],
      user: null,
      users: [],
      status: null,
      statuses: [],
      importances: ['پایین', 'متوسط', 'بالا'],
      files: [],
      lockButtons: false,
    }
  },
  watch: {
    ticket(ticket) {
      this.section = {
        id: ticket.lastCompanySection.id,
        title: ticket.lastCompanySection.title
      };
    },
    section(section) {
      this.roles = [];
      this.users = [];
      this.role = null;
      this.user = null;
    },
    role(role) {
      if (role) {
        this.user = null;
      }
    },
    user(user) {
      if (user) {
        this.role = null;
      }
    },
  },
  methods: {
    getCompanySections() {
      if (this.companySections?.length > 0)
        return;

      CompanyService.getSectionsForReferringByCompanyId(this.ticket.companyId).then(response => {
        let result = response.data;
        if (result.success) {
          this.companySections = result.data;
          
          this.section = this.companySections.filter(cs => cs.id == this.ticket.lastCompanySection.id)[0];
        }
        else {
          this.$toast.error(result.message);
        }
      }).then(() => this.getStatusesByCompany()
      ).catch(e => {
        console.log(e);
      });
    },
    getRolesByCompanySection() {
      if (this.roles?.length > 0 | !this.section?.id)
        return;

      RoleService.listRolesByCompanySectionId(this.section.id).then(response => {
        let result = response.data;
        if (result.success) {
          this.roles = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUsersByCompanySection() {
      if (this.users?.length > 0 | !this.section?.id)
        return;
      
      UserService.listUsersByCompanySectionId(this.section.id).then(response => {
        let result = response.data;
        if (result.success) {
          this.users = result.data.map(user => ({ ...user, displayProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getStatusesByCompany() {
      if (this.statuses?.length > 0)
        return;
      
      TicketService.getStatusesByCompany(this.ticket.companyId).then(response => {
        let result = response.data;
        if (result.success) {
          this.statuses = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    submitForm() {
      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      this.lockButtons = true;

      let referral = new FormData();
      referral.append('TicketId', this.ticket.id);
      if (this.section) {
        referral.append('CompanySectionId', this.section.id);
      }
      if (this.description) {
        referral.append('SenderComment', this.description);
      }
      if (this.user) {
        referral.append('ReceiverUserId', this.user.id);
      }
      if (this.role) {
        referral.append('ReceiverRoleId', this.role.id);
      }
      if (this.status) {
        referral.append('TicketStatusId', this.status.id);
      }
      for (var i = 0; i < this.files.length; i++) {
        referral.append("Files", this.files[i]);
      }

      BaseService.postFile('/Ticket/ReferTicket', referral).then(response => {
        let result = response.data;

        if (result.success) {
          this.description = '';
          this.section = null;
          this.role = null;
          this.user = null;
          this.status = null;
          this.$refs.referTicketFileSelector.files = [];

          this.$emit('referred');
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
      
      this.lockButtons = false;
      this.v.$reset();
    },
    updateFiles(files) {
      this.files = files;
    },
  },
  created() {
  },
  validations() {
    let valObj = {
      section: {
        requiredIf: helpers.withMessage('لطفا "بخش"، "نقش" یا "کاربر" هدف ارجاع را انتخاب کنید', requiredIf(!this.role && !this.user)),
      },
      description: {
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "متن توضیحات"، 65000 کاراکتر است', maxLength(65000)),
      },
    };

    return valObj;
  }
}
</script>